import * as React from 'react';
export const ethSvg = React.forwardRef(function ethSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#5469D4',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm15.997 5.333-.143.486v14.106l.143.143 6.548-3.87-6.548-10.865Z',
      fill: '#C2CCF4',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.996 5.333 9.448 16.198l6.548 3.87V5.333Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm15.997 21.306-.08.098v5.025l.08.236 6.552-9.227-6.552 3.868Z',
      fill: '#C2CCF4',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.996 26.665v-5.36l-6.548-3.867 6.548 9.227Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm15.995 20.07 6.548-3.87-6.548-2.976v6.847Z',
      fill: '#8698E8',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm9.448 16.2 6.548 3.87v-6.846L9.448 16.2Z',
      fill: '#C2CCF4',
    }),
  );
});
ethSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var eth = {
  category: 'brand',
  colorable: false,
  name: 'eth',
  svg: ethSvg,
};
